// extracted by mini-css-extract-plugin
export default {"root":"Access__root--2MLtM"};